// extracted by mini-css-extract-plugin
export default {"otherPrice":"Price-module-otherPrice","includedPrice":"Price-module-includedPrice"};